module.exports = __webpack_public_path__ + "/assets/img/icon_return_slipfce25494.svg";